import styled from 'styled-components';
import { AppButton } from 'components/atoms';

export const ExpandButton = styled(AppButton)`
    background-color: unset !important;
    border-radius: 0 !important;
    width: 100%;
`;
